import React from 'react';

import { Divider, Grid, Typography } from 'core/components/library';
import { Avatar, Text, Button, Alert } from 'core/components';

import * as hlprs from 'core/helpers';
import * as icons from 'core/icons';

const Profile = props => {
    const { values, editing, handleChange, execAction, refreshing } = props;

    const [openDialog, setOpenDialog] = React.useState(false);
    const [current, setCurrent] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirm, setConfirm] = React.useState('');

    const action = () => {
        const accion = {
            api: 'login/change-password',
            metodo: 'post',
            data: {
                currentPassword: current,
                newPassword: password
            }
        };
        execAction(accion, [
            data => {
                setCurrent('');
                setPassword('');
                setConfirm('');
                setOpenDialog(true);
            }
        ]);
    };

    return (
        <>
            <Grid container spacing={1}>
                <Grid item>
                    <Avatar
                        size='large'
                        sx={{ marginBottom: '30px', marginLeft: '10px' }}
                        value={values.nombre}
                        image={hlprs.getAvatar(values.id, values.avatar)}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='nombre'
                        label='Nombre'
                        value={values.nombre}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={4}>
                    <Text
                        fullWidth
                        name='puesto'
                        label='Cargo'
                        value={values.puesto}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='email'
                        label='eMail'
                        value={values.email}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                spacing={1}
                style={{ marginTop: '10px', marginBottom: '20px' }}
            >
                <Grid item xs>
                    <Typography variant='caption'>
                        Datos de inicio de sesión
                    </Typography>
                    <Divider />
                </Grid>
            </Grid>

            <Grid container spacing={5}>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='login'
                        label='Login'
                        value={values.login}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item xs>
                    <Grid container direction='column' spacing={1}>
                        <Grid item xs>
                            <Text
                                fullWidth
                                autoComplete='off'
                                type='password'
                                name='current'
                                label='Contraseña Actual'
                                value={current}
                                onChange={data => setCurrent(data[0].value)}
                                editing={true}
                            />
                        </Grid>
                        <Grid item xs>
                            <Divider />
                        </Grid>
                        <Grid item xs>
                            <Text
                                autoComplete='off'
                                fullWidth
                                type='password'
                                name='password'
                                label='Nueva Contraseña'
                                value={password}
                                onChange={data => setPassword(data[0].value)}
                                editing={true}
                            />
                        </Grid>
                        <Grid item xs>
                            <Text
                                autoComplete='off'
                                type='password'
                                error={password !== '' && password !== confirm}
                                fullWidth
                                name='confir,'
                                label='Confirma Contraseña'
                                value={confirm}
                                onChange={data => setConfirm(data[0].value)}
                                editing={true}
                            />
                        </Grid>
                        <Grid item xs>
                            <Button
                                toolTipText='Cambiar Contraseña'
                                disabled={
                                    current === '' ||
                                    password === '' ||
                                    password !== confirm
                                }
                                onClick={event => action()}
                                counter={0}
                                busy={refreshing}
                                icon={<icons.PasswordIcon />}
                                float={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Alert
                open={openDialog}
                title='Contraseña Cambiada correctamente'
                text={`La contraseña ha sido cambiada satisfactoriamente en el sistema.`}
                cancel={() => {
                    setOpenDialog(false);
                }}
            />
        </>
    );
};

export default Profile;
